import BarProfitToolExceptions from '../../../../../../../../target/gen-thrift/typescript/bar_profit_tool_Exceptions_types';

import {
    validateGateFormField,
    validateBarProfitInputSetInputText,
    parseBarProfitInputSetInputText,
    formatBarProfitInputSetInputValue,
    ensureUnauthenticatedUserSessionIdInCookie,
    createFirstQuestionSet,
    answerFirstQuestionSet,
    createSecondQuestionSet,
    answerSecondQuestionSet,
    logException,
} from '../../utils';

import getUserIdentificationInfo from '../../../../shared/utils/IdentifyingUser';

export const ActionTypes = {
    SET_ACTIVE_BREAKDOWN: 'SET_ACTIVE_BREAKDOWN',
    SET_FIELD_INPUTS: 'SET_FIELD_INPUTS',
    SET_GATE_FORM_FIELD_VALUE: 'SET_GATE_FORM_FIELD_VALUE',
    SET_GATE_STATE: 'SET_GATE_STATE',
    SET_GATE_ERROR_MESSAGE: 'SET_GATE_ERROR_MESSAGE',
    SET_PRESENTATION_ID: 'SET_PRESENTATION_ID',
    UNAUTHENTICATED_USER_SESSION_ID_ACQUIRED: 'UNAUTHENTICATED_USER_SESSION_ID_ACQUIRED'
};

export function handleBarProfitInputComponentMount() {
    return function (dispatch, getState) {

        ensureUnauthenticatedUserSessionIdInCookie(function(sessionId) {
            createSecondQuestionSet(sessionId, function(presentationId) {
                dispatch({
                    type: ActionTypes.UNAUTHENTICATED_USER_SESSION_ID_ACQUIRED,
                    sessionId: sessionId
                });
                dispatch({
                    type: ActionTypes.SET_PRESENTATION_ID,
                    presentationId: presentationId
                });
                dispatch({
                    type: ActionTypes.SET_GATE_STATE,
                    gateShown: false,
                    initialInputFormId: null
                });
            }, function(exception, args) {
                if (exception instanceof BarProfitToolExceptions.FirstQuestionSetNotAnsweredException) {
                    createFirstQuestionSet(sessionId, function(initialInputFormId, sessionId) {
                        dispatch({
                            type: ActionTypes.UNAUTHENTICATED_USER_SESSION_ID_ACQUIRED,
                            sessionId: sessionId
                        });
                        dispatch({
                            type: ActionTypes.SET_GATE_STATE,
                            gateShown: true,
                            initialInputFormId: initialInputFormId
                        });
                    });
                } else {
                    logException('28AB5FE9-D0E8-4BC8-8FDC-F3ACAF32DAF2', exception, args);
                    throw exception;
                }
            });
        });
    }
}

export function handleGateFormFieldValueChange(field, value) {
    return function(dispatch, getState) {

        const {isValid, errorMessage} = validateGateFormField(field, value);

        dispatch({
            type: ActionTypes.SET_GATE_FORM_FIELD_VALUE,
            field: field,
            value: value,
            isValid: isValid,
            errorMessage: errorMessage
        });
    };
}

function validateGateForm(dispatch, gateFormData) {
    let formIsValid = true;
    let validGateFieldValues = {};

    for (let field in gateFormData) {
        if (gateFormData.hasOwnProperty(field)) {
            let value = gateFormData[field].value;

            const {isValid, errorMessage} = validateGateFormField(field, value);

            formIsValid = formIsValid && isValid;

            if (!isValid) {
                dispatch({
                    type: ActionTypes.SET_GATE_FORM_FIELD_VALUE,
                    field: field,
                    value: value,
                    isValid: isValid,
                    errorMessage: errorMessage
                });
            } else {
                validGateFieldValues[field] = value;
            }
        }
    }

    return {
        formIsValid: formIsValid,
        validGateFieldValues: validGateFieldValues
    }
}

export function handleGateFormSubmitClick(callbackFunctionOnPresentationId) {
    return function(dispatch, getState) {
        const gateFormData = getState().gate.formData;

        let {formIsValid, validGateFieldValues} = validateGateForm(dispatch, gateFormData);

        if (formIsValid) {
            const initialInputFormId = getState().gate.initialInputFormId;

            answerFirstQuestionSet(initialInputFormId, validGateFieldValues, function() {
                    dispatch({
                        type: ActionTypes.SET_GATE_STATE,
                        gateShown: false,
                        initialInputFormId: null
                    });
                    $.scrollTo("#lets-go");

                    const sessionId = getState().unauthenticatedSession.sessionId;
                    createSecondQuestionSet(sessionId, function(presentationId) {
                        dispatch({
                            type: ActionTypes.SET_PRESENTATION_ID,
                            presentationId: presentationId
                        });

                        if (callbackFunctionOnPresentationId) {
                            callbackFunctionOnPresentationId();
                        }
                    });
            });

            window.BevspotPlatformClient.Observer.trackConversion.barProfitSubmission({
                email: validGateFieldValues.email,
                phone: validGateFieldValues.phoneNumber,
                bar_name: validGateFieldValues.barName,
                first_name: validGateFieldValues.firstName,
                last_name: validGateFieldValues.lastName,
                zip_code: validGateFieldValues.zipCode,
                bar_connection: validGateFieldValues.barConnection,
                subscribe_to_blog: validGateFieldValues.subscribeToBlog,
                hubspot_cookie: Utils.getCookie('hubspotutk')
            });
        } else {
            dispatch({
                type: ActionTypes.SET_GATE_ERROR_MESSAGE,
                errorMessage: "Please, fix the invalid fields before you can submit"
            });
        }
    };
}

export function handleBreakDownIndicatorClick(setName, breakdown) {
    return function(dispatch, getState) {
        const state = getState();

        if (state.barProfitInput.breakdownsBySetName[setName].activeBreakdown != breakdown) {
            dispatch({
                type: ActionTypes.SET_ACTIVE_BREAKDOWN,
                setName: setName,
                activeBreakdown: breakdown,
            });
        }
    };
}

export function handleFieldSliderInputChange(setName, breakdown, field, value) {
    return function(dispatch, getState) {

        let text = formatBarProfitInputSetInputValue(setName, value);

        dispatch({
            type: ActionTypes.SET_FIELD_INPUTS,
            setName: setName,
            breakdown: breakdown,
            field: field,
            value: value,
            text: text,
            isValid: true,
            errorMessage: ""
        });
    };
}

export function handleFieldTextInputChange(setName, breakdown, field, text) {
    return function(dispatch, getState) {
        const state = getState();
        const stateFieldInputs = state.barProfitInput.breakdownsBySetName[setName].fieldsByBreakdown[breakdown].valuesByField[field];

        let {isValid, errorMessage} = validateBarProfitInputSetInputText(setName, text);

        let value;
        if (isValid) {
            value = parseBarProfitInputSetInputText(setName, text);
        } else {
            value = stateFieldInputs.value;
        }

        dispatch({
            type: ActionTypes.SET_FIELD_INPUTS,
            setName: setName,
            breakdown: breakdown,
            field: field,
            value: value,
            text: text,
            isValid: isValid,
            errorMessage: errorMessage
        });
    };
}

export function handleFieldTextInputBlur(setName, breakdown, field, text) {
    return function(dispatch, getState) {
        const state = getState();
        const stateFieldInputs = state.barProfitInput.breakdownsBySetName[setName].fieldsByBreakdown[breakdown].valuesByField[field];

        let {isValid, errorMessage} = validateBarProfitInputSetInputText(setName, text);

        let value;
        if (isValid) {
            value = parseBarProfitInputSetInputText(setName, text);
            text = formatBarProfitInputSetInputValue(setName, value);
        } else {
            value = stateFieldInputs.value;
        }

        dispatch({
            type: ActionTypes.SET_FIELD_INPUTS,
            setName: setName,
            breakdown: breakdown,
            field: field,
            value: value,
            text: text,
            isValid: isValid,
            errorMessage: errorMessage
        });
    };
}

export function handleBarProfitToolDataFormSubmitClick() {
    return function(dispatch, getState) {
        const breakdownsBySetName = getState().barProfitInput.breakdownsBySetName;

        let formIsValid = true;
        let validDataValues = {};

        for (let setName in breakdownsBySetName) {
            if (breakdownsBySetName.hasOwnProperty(setName)) {

                const activeBreakdown =  breakdownsBySetName[setName].activeBreakdown;
                const fieldsByBreakdown = breakdownsBySetName[setName].fieldsByBreakdown;

                let setValues = {};

                for (let breakdown in fieldsByBreakdown) {
                    if (fieldsByBreakdown.hasOwnProperty(breakdown)) {

                        let valuesByField =  fieldsByBreakdown[breakdown].valuesByField;

                        for (let field in valuesByField) {
                            if (valuesByField.hasOwnProperty(field)) {

                                if (breakdown === activeBreakdown) {
                                    const fieldValue = valuesByField[field].text;

                                    let {isValid, errorMessage} = validateBarProfitInputSetInputText(setName, fieldValue);

                                    formIsValid = formIsValid && isValid;

                                    if (!isValid) {
                                        dispatch({
                                            type: ActionTypes.SET_FIELD_INPUTS,
                                            setName: setName,
                                            breakdown: breakdown,
                                            field: field,
                                            value: valuesByField[field].value,
                                            text: valuesByField[field].text,
                                            isValid: isValid,
                                            errorMessage: errorMessage
                                        });
                                    } else {
                                        setValues[field] = fieldValue.replace(/[^0-9.]+/g, '');
                                    }

                                } else {
                                    if (!setValues.hasOwnProperty(field)) {
                                        setValues[field] = null;
                                    }
                                }
                            }
                        }
                    }
                }

                validDataValues[setName] = setValues;

            }
        }

        const gateState = getState().gate;
        if (gateState.shown) {
            const gateFormIsValid = validateGateForm(dispatch, gateState.formData).formIsValid;

            if (gateFormIsValid) {
                dispatch(handleGateFormSubmitClick(function() {
                    if (formIsValid) {
                        const presentationId = getState().barProfitInput.presentationId;
                        answerSecondQuestionSet(presentationId, validDataValues, function(submissionId) {
                            window.location.href = '/bar-profit-tool/?data-id=' + submissionId;
                        });
                    }
                }));
            } else {
                $.scrollTo("#get-started");
                dispatch({
                    type: ActionTypes.SET_GATE_ERROR_MESSAGE,
                    errorMessage: "Please, complete and submit the form to proceed"
                });
            }
        } else {
            if (formIsValid) {
                const presentationId = getState().barProfitInput.presentationId;
                answerSecondQuestionSet(presentationId, validDataValues, function(submissionId) {
                    window.location.href = '/bar-profit-tool/?data-id=' + submissionId;
                });
            }
        }
    };
}
